import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@/index.css";
import "@/lib/medianOneSignal";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker with auto-update + reload
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // updateViaCache:'none' => the browser must re-fetch /sw.js from network (never HTTP cache),
    // so a bumped CACHE version is always detected and the new build activates.
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((reg) => {
      // Check for a new version on load, and periodically
      reg.update().catch(() => {});
      setInterval(() => reg.update().catch(() => {}), 60_000);
      // If a new SW is already waiting at load time, activate it immediately
      if (reg.waiting && navigator.serviceWorker.controller) reg.waiting.postMessage("SKIP_WAITING");

      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          // A new SW is installed and there's already a controller => update available
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            nw.postMessage("SKIP_WAITING");
          }
        });
      });

      // Check for a fresh build every time the installed app is reopened/focused,
      // so users get updates without deleting & reinstalling.
      const checkForUpdate = () => { if (document.visibilityState === "visible") reg.update().catch(() => {}); };
      document.addEventListener("visibilitychange", checkForUpdate);
      window.addEventListener("focus", checkForUpdate);
    }).catch(() => {});

    // When the active SW changes, reload once to pick up the new build
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
